export const HTTPStatusCodes = Object.freeze({
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NoContent: 204,
  MiscellaneousPersistentWarning: 299,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  RequestTimeout: 408,
  Conflict: 409,
  UnprocessableContent: 422,
  TooManyRequests: 429,
  InternalServerError: 500
});
